import * as React from 'react';
import classNames from 'classnames';
import './hamburgerButton.module.scss';

type Props = {
  color: 'white' | 'dark';
  active: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: () => any;
  className?: string;
  styleName?: string;
};

export class HamburgerButton extends React.Component<Props> {
  render() {
    const { active, color, onClick, className } = this.props;
    return (
      <div
        id="hamburger-button"
        styleName={classNames('hamburger-button', color, { open: active })}
        className={className}
        onClick={onClick}
      >
        <span />
        <span />
        <span />
      </div>
    );
  }
}
